import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useSearchParams } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { Welcome } from "./pages/Welcome";
import { Test } from "./pages/Test";
import { TestUK } from "./pages/TestUK";
import { Complete } from "./pages/Complete";
import { AdminLogin } from "./pages/AdminLogin";
import { AdminDashboard } from "./pages/AdminDashboard";

/* Route /test : si le paramètre ref commence par APUK- → flux UK, sinon → flux FR existant */
function TestPage() {
  const [sp] = useSearchParams();
  const ref = sp.get('ref');
  if (ref && ref.startsWith('APUK-')) return <TestUK />;
  return <Test />;
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          {/* Guest Routes */}
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/test" element={<TestPage />} />
          <Route path="/complete" element={<Complete />} />
          
          {/* Admin Routes */}
          <Route path="/admin-secure" element={<AdminLogin />} />
          <Route path="/admin-secure/dashboard" element={<AdminDashboard />} />
          
          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/admin-secure" replace />} />
          <Route path="*" element={<Navigate to="/admin-secure" replace />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
